import React, { useState, useRef, useEffect } from "react";

// Local Assets
import adhocLoginIcon from "../../../assets/icons/adhoc-login.svg";

// Local Stylesheet
import "./AdhocLoginScreens.scss";

// Authentication Functions
import { saveGuestLogin, saveGuestTokens } from "../../../auth";

// Apollo Client
import { gql, useMutation } from "@apollo/client";

// External Libraries
import { jwtDecode } from "jwt-decode";

// Custom Components and Utilities
import { notify } from "../../../components/Notify/Notify";

export const UPLOAD_DOCUMENT_REQUEST_SUBMISSIONS = gql`
  mutation (
    $documentSubmissionsInfo: [DocumentRequestSubmissionInputType!]!
    $files: [Upload!]!
  ) {
    uploadDocumentRequestSubmissions(
      documentSubmissionsInfo: $documentSubmissionsInfo
      files: $files
    ) {
      success
      documentRequestSubmissions {
        id
        submissionStatus
        submissionFile
        submittedAt
      }
    }
  }
`;

export const DOCUMENT_REQUEST_TOKEN_AUTH = gql`
  mutation (
    $username: String!
    $password: String!
    $documentRequestId: String!
  ) {
    data: documentRequestTokenAuth(
      username: $username
      password: $password
      documentRequestId: $documentRequestId
    ) {
      user {
        id
        email
      }
      token
    }
  }
`;

const AdhocLoginScreens = () => {
  const [decodedTokenData, setDecodedTokenData] = useState(null);
  const [pinInputs, setPinInputs] = useState(["", "", "", ""]);
  const inputRefs = [useRef(), useRef(), useRef(), useRef()];
  const submitButtonRef = useRef();

  const handleChange = (index, value) => {
    const newInputs = [...pinInputs];
    newInputs[index] = value;

    if (index < 3 && value !== "") {
      inputRefs[index + 1].current.focus();
    } else if (index === 3 && value !== "") {
      submitButtonRef.current.focus();
    }

    setPinInputs(newInputs);
  };

  const handleKeyDown = (index, e) => {
    if (e.keyCode === 8 && pinInputs[index] === "" && index > 0) {
      // If backspace is pressed in an empty input field, move focus to the previous input
      inputRefs[index - 1].current.focus();
    }
  };

  // Handle signin
  const [signinGuestUser, { loading: isSigninGuestUserLoading }] = useMutation(
    DOCUMENT_REQUEST_TOKEN_AUTH,
    {
      onError: (error) => {
        if (error.message === "Please enter valid credentials") {
          notify("Error", "Please enter a valid pin.", "error");
        } else {
          notify("Error", error.message, "error");
        }

        console.error("Sign in error:", error);
      },
      onCompleted: (result) => {
        saveGuestLogin(true);
        saveGuestTokens(result?.data?.token);
        notify("Success", "You have successfully login.", "success");
        window.location.href = "/guest-form-submission";
      },
    }
  );
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("u");
    if (!code) {
      return;
    }
    const decoded = jwtDecode(code);
    setDecodedTokenData(decoded);
    // You can now use the value of `code` as needed
  }, []);

  return (
    <div className="adhoc-login-container">
      <div className="adhoc-login-screens">
        <div>
          <img src={adhocLoginIcon} alt="auth-icon" />
        </div>
        <div>
          <h2 className="title">Portal Sign In</h2>
          <p className="description">
            Welcome to the portal. Please enter the sign-in code that was sent
            in the email request received to continue.
          </p>
        </div>

        <div className="pin-input">
          {pinInputs.map((value, index) => (
            <input
              key={index}
              type="text"
              maxLength="1"
              className="pin-input-felid"
              ref={inputRefs[index]}
              value={value}
              onChange={(e) => handleChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(index, e)}
            />
          ))}
        </div>
        <button
          className="signin-btn"
          ref={submitButtonRef}
          disabled={decodedTokenData === null || isSigninGuestUserLoading}
          onClick={() => {
            signinGuestUser({
              variables: {
                username: decodedTokenData?.document_request_user?.email,
                password: pinInputs.join(""),
                documentRequestId: decodedTokenData?.document_request_id,
              },
            });
          }}
        >
          Sign In
        </button>
      </div>
    </div>
  );
};

export default AdhocLoginScreens;
